import { useAnchor } from '../../shared/hooks/use-anchor';

import { SectionHeader } from '@/shared/components/section-header';
import { useRestoreScroll } from '../../insight-layout/hook/use-insight-scroll-container';
import { CONVERSATION_PAGE_ANCHOR } from '../constants';
import { BrandsProductsSection } from './brand-product.section';
import { ThemeSection } from './theme.section';
import { WordCloudSection } from './word-cloud-section';

export function ConversationPage() {
  useAnchor({ currentPath: '/workspace/$workspaceId/insight/conversation' });
  useRestoreScroll();

  return (
    <>
      <div>
        <SectionHeader title="Themes" description="Discover what topics people are discussing" />
        <ThemeSection />
      </div>

      <div data-anchor={CONVERSATION_PAGE_ANCHOR.BRANDS_PRODUCTS_SECTION}>
        <SectionHeader
          title="Related brands and products"
          description="See which brands and products are being mentioned"
        />
        <BrandsProductsSection />
      </div>

      <div data-anchor={CONVERSATION_PAGE_ANCHOR.WORD_CLOUD_SECTION}>
        <WordCloudSection className="mb-[130px]" />
      </div>
    </>
  );
}
